import { cx } from "cva";
import { type PropsWithChildren } from "react";

import { CircularProgress } from "../CircularProgress";
import { LinkButtonProps, variants } from ".";

export const LinkButton = ({
  className,
  appearance,
  widthType,
  align,
  loading,
  fontSize,
  children,
  ...props
}: PropsWithChildren<LinkButtonProps>) => {
  return (
    <button type="button" className={cx(className, variants({ appearance, widthType, align, fontSize }))} {...props}>
      {loading ? <CircularProgress /> : children}
    </button>
  );
};
